import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AuthProvider } from "./components/AuthProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import ShellLayout from "./components/layout/ShellLayout";
import { CompletionRitualModal } from "./components/timer/CompletionRitualModal";
import "./App.css";


const TimerPage = lazy(() => import("./pages/Timer"));
const LogPage = lazy(() => import("./pages/Log"));
const FastingSettingsPage = lazy(() => import("./pages/FastingSettings"));
const AuthPage = lazy(() => import("./pages/Auth"));
const AdminPage = lazy(() => import("./pages/Admin"));
import RequireAdmin from "./components/RequireAdmin";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5 * 60 * 1000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const Loader = () => (
  <div className="p-6 text-center lab-label">LOADING MODULE…</div>
);

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <BrowserRouter>
            <AuthProvider>
              <ShellLayout>
                <Suspense fallback={<Loader />}>
                  <Routes>
                    <Route path="/" element={<TimerPage />} />
                    <Route path="/log" element={<LogPage />} />
                    <Route path="/settings" element={<FastingSettingsPage />} />
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/admin" element={<RequireAdmin><AdminPage /></RequireAdmin>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Suspense>
              </ShellLayout>
              <CompletionRitualModal />
              <Toaster />

            </AuthProvider>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
